class Offcanvas {
    constructor() {
        this.buttonList = document.querySelectorAll('[data-offcanvas]');
        this.background = document.querySelector('.js-offcanvas-background');
    }

    init() {
        if (this.buttonList.length > 0 ) {
            this.bindEvents();
        }
    }

    bindEvents() {
        const background = this.background;
        const buttonList = this.buttonList;

        buttonList.forEach(button => {
            button.addEventListener('click', function(event) {
               let element;

               if (event.target.dataset.hasOwnProperty('offcanvas')) {
                   element = event.target;
               } else if (event.target.parentElement.dataset.hasOwnProperty('offcanvas')) {
                   element = event.target.parentElement;
               }

               if (element && element.dataset.hasOwnProperty('target')) {
                   const target = document.querySelector(element.dataset.target);
                   target.classList.toggle('is-visible')
                   button.classList.toggle('is-open')
                   background.classList.toggle('is-visible');

                   if (element.dataset.hasOwnProperty('eventClicktext')) {
                       element.dataset.eventClicktext = element.dataset.eventClicktext === 'flap-icon-open' ? 'flap-icon-close' : 'flap-icon-open';
                   }
               }
           });
        });

        if (this.background) {
            this.background.addEventListener('click', function (event) {
                buttonList.forEach(button => {
                    if (button.classList.contains('is-open')) {
                        console.log('click background')
                        button.click();
                    }
                })
            })
        }
    }
}

export default new Offcanvas();
